import Form from '@admin/components/form'
import PropTypes from 'prop-types'
import React from 'react'

class Edit extends React.Component {

  static contextTypes = {
    modal: PropTypes.object
  }

  static propTypes = {
    domain_segment: PropTypes.object
  }

  _handleCancel = this._handleCancel.bind(this)
  _handleSuccess = this._handleSuccess.bind(this)

  render() {
    return <Form { ...this._getForm() } />
  }

  _getForm() {
    const { domain_segment } = this.props
    return {
      title: 't(Edit Domain Segment)',
      method: 'PATCH',
      endpoint: `/api/admin/truevail/admin/deliverability/domain_segments/${domain_segment.id}/edit`,
      action: `/api/admin/truevail/admin/deliverability/domain_segments/${domain_segment.id}`,
      onCancel: this._handleCancel,
      onSuccess: this._handleSuccess,
      sections: [
        {
          fields: [
            { 
              label: 't(Sending Rate)', 
              name: 'sending_rate',
              type: 'numericfield', 
              required: true 
            },
            { 
              label: 't(Warming Enabled)', 
              name: 'warming_enabled',
              type: 'checkbox'
            }
          ]
        }
      ]
    }
  }

  _handleCancel() {
    this.context.modal.close()
  }

  _handleSuccess(result) {
    this.context.modal.close()
  }

}

export default Edit
